import { useTranslation } from '@thoughtspot/i18n';
import { Card, CardBody, CardHeader, } from '@thoughtspot/radiant-react/widgets/card';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useCallback } from 'react';
import styles from './feature-card.module.scss';
export const FeatureCard = ({ feature, onValueChange, }) => {
    const { t } = useTranslation();
    const { configName, value } = feature;
    const label = t(`${configName}.label`) || configName;
    const description = t(`${configName}.infoTooltip`) || '';
    const handleToggleChange = useCallback((e) => {
        const target = e.target;
        const newValue = target.checked ? 'true' : 'false';
        onValueChange(configName, newValue);
    }, [configName, onValueChange]);
    return (React.createElement(Card, { className: styles.cardWrapper, isTabDisabled: true, "data-testid": `feature-card-${configName}` },
        React.createElement(CardHeader, { className: styles.cardHeader },
            React.createElement("div", { className: styles.cardHeaderRow },
                React.createElement(Typography, { variant: "content-label", noMargin: true, className: styles.featureCardName }, label),
                React.createElement("div", { className: styles.controlContainer },
                    React.createElement(Toggle, { label: label, hideLabel: true, checked: value === 'true', onChange: handleToggleChange, name: configName, "data-testid": `feature-toggle-${configName}` })))),
        description && (React.createElement(CardBody, { className: styles.cardBody },
            React.createElement(Typography, { variant: "body-normal", color: Colors.info, noMargin: true, className: styles.description }, description)))));
};
//# sourceMappingURL=feature-card.js.map